export const competitionSubTypes = {
  EMPTY: 'EMPTY',
  MFB: 'MFB',
  KAVOSZ: 'KAVOSZ',
  EXIM: 'EXIM'
}

export const getReadableCompetitionSubType = id => {
  switch (id) {
    case competitionSubTypes.MFB:
      return 'MFB'
    case competitionSubTypes.KAVOSZ:
      return 'KAVOSZ'
    case competitionSubTypes.EXIM:
      return 'EXIM'
    case competitionSubTypes.EMPTY:
      return ''
  }
}

export const allCompetitionTypes = [
  competitionSubTypes.KAVOSZ,
  competitionSubTypes.MFB,
  competitionSubTypes.EXIM,
  competitionSubTypes.EMPTY
]
